export default function WhyInsurance() {
  const reasons = [
    {
      title: 'Medical Emergencies Are Expensive',
      description: 'A single hospitalization can cost ₹5-10 lakhs. Without insurance, your savings vanish overnight.',
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
        </svg>
      ),
      stat: '₹8.5L',
      statLabel: 'Avg. ICU Cost',
    },
    {
      title: 'Income Protection Is Critical',
      description: 'If you\'re the breadwinner, your family depends on your income. Term insurance ensures they\'re protected.',
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      ),
      stat: '10-15x',
      statLabel: 'Income Coverage',
    },
    {
      title: 'Family Dependency Risk',
      description: 'Home loans, education costs, daily expenses - ensure your family\'s lifestyle doesn\'t change.',
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
      stat: '₹50L+',
      statLabel: 'Avg. Family Needs',
    },
    {
      title: 'Start Young, Pay Less',
      description: 'Insurance premiums are lowest in your 20s-30s. Delaying means paying more for the same coverage.',
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="9" strokeWidth="2"/>
          <g fill="currentColor" stroke="none">
            <rect x="8" y="8" width="7.5" height="1.2"/>
            <rect x="8" y="10.5" width="7.5" height="1.2"/>
            <path d="M13 11.7 Q13.5 12.2 13.5 13.5 Q13.5 15 12 15.8 Q11 16.3 9.8 16.3 L9.3 16.3 L9.3 15.5 Q10.5 15.5 11.3 15 Q12.5 14.3 12.5 13.2 Q12.5 12.3 12 11.7 Z M9.3 15.5 L9 15.8 L14 20 L14.5 19.5 L10 15.2 Z"/>
          </g>
        </svg>
      ),
      stat: '50%',
      statLabel: 'Save on Premiums',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Insurance <span className="text-blue-600">Can't Wait</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Understanding the importance of financial protection for you and your family
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-white to-blue-50 p-6 rounded-2xl border border-gray-200 hover:border-blue-300 hover:shadow-xl transition-all duration-300"
            >
              <div className="text-blue-600 mb-4 group-hover:scale-110 transition-transform">
                {reason.icon}
              </div>
              
              <h3 className="font-bold text-lg text-gray-900 mb-2">
                {reason.title}
              </h3>
              
              <p className="text-gray-600 text-sm mb-4">
                {reason.description}
              </p>
              
              <div className="pt-4 border-t border-gray-200">
                <div className="text-2xl font-bold text-blue-600">
                  {reason.stat}
                </div>
                <div className="text-xs text-gray-500 font-medium">
                  {reason.statLabel}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="bg-gradient-to-r from-blue-600 to-green-600 rounded-3xl p-8 md:p-12 text-center text-white">
          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            Don't Wait for Tomorrow. Secure Your Family Today.
          </h3>
          <p className="text-blue-100 mb-6 max-w-2xl mx-auto">
            Get a free financial health check and personalized insurance recommendations
            from an expert with 20+ years of experience.
          </p>
          <a
            href="#contact"
            className="inline-block bg-white text-blue-600 px-8 py-4 rounded-xl hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl font-semibold text-lg"
          >
            Get Free Consultation
          </a>
        </div>
      </div>
    </section>
  );
}
